<template>
  <RouterView />
</template>

<script setup lang="ts">
import { onMounted } from "vue";
import { useNotificationSetup } from "./new_design/notifications/application/composables/useNotificationSetup";
import { handlePrevRouteObserver } from "./router/handlePrevRoute";
import useAuthStore from "./new_design/auth/stores/auth";
console.log("test deployjment");
useNotificationSetup();
useAuthStore();
console.log("**** VITE_API_BASEURL:", import.meta.env.VITE_API_BASEURL);
onMounted(() => {
  handlePrevRouteObserver();
});
</script>

<style>
.sidebar {
  width: 0px;
}

body {
  overflow-y: auto;
}
</style>
